/* eslint-disable @typescript-eslint/ban-types */
import QueryTags from '../types/QueryTags'
import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions'
import { BaseQueryFn, FetchArgs, FetchBaseQueryError, FetchBaseQueryMeta } from '@reduxjs/toolkit/query/react'

const basePath = '/admin/tenants'

const TenantEndpoints = (builder: EndpointBuilder<
  BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError, {}, FetchBaseQueryMeta>, QueryTags, 'data'>) =>
  ({
    fetchTenants: builder.query<any, void>({
      query: () => basePath,
      providesTags: ['tenants']
    }),

    fetchTenantById: builder.query<any, number | string>({
      query: (id) => `${basePath}/${id}`,
      providesTags: ['tenants']
    }),

    createTenant: builder.mutation<any, any>({
      query: (body) => ({
        url: basePath,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['tenants']
    }),

    suspendTenant: builder.mutation<any, number | string>({
      query: (id) => ({
        url: `${basePath}/${id}/suspend`,
        method: 'POST',
      }),
      invalidatesTags: ['tenants']
    }),

    reactivateTenant: builder.mutation<any, number | string>({
      query: (id) => ({
        url: `${basePath}/${id}/reactivate`,
        method: 'POST',
      }),
      invalidatesTags: ['tenants']
    }),

    deleteTenant: builder.mutation<any, number | string>({
      query: (id) => ({
        url: `${basePath}/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['tenants']
    }),

    fetchTenantUsers: builder.query<any, number | string>({
      query: (id) => `${basePath}/${id}/users`,
      providesTags: ['appUsers']
    }),

    createTenantUser: builder.mutation<any, { tenantId: number | string; body: any }>({
      query: ({ tenantId, body }) => ({
        url: `${basePath}/${tenantId}/users`,
        method: 'POST',
        body,
      }),
      invalidatesTags: ['appUsers']
    }),
  })

export default TenantEndpoints
